import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { MultichainWalletProvider } from './MultichainWalletProvider';
/** Shared browser-wallet setup for frontend and admin-panel. */
export function AppWalletProvider({ children, appName, projectId, solanaRpc, autoInitSolanaProgram, onSolanaProgramReady, }) {
    return (_jsx(MultichainWalletProvider, { appName: appName, projectId: projectId, solanaWalletMode: "browser", solanaRpc: solanaRpc, autoInitSolanaProgram: autoInitSolanaProgram, onSolanaProgramReady: onSolanaProgramReady, children: children }));
}
